module.exports = __webpack_public_path__ + "15c8df8fcb62dc307491dd349690dac7.pdf";